// extracted by mini-css-extract-plugin
export default {"eventBoard":"EventBoard_eventBoard__E4oz9"};